import { getFetch } from '../fetch';
import { apiConfig } from '../config';
import { CourseContainers } from '../../../typings';

export function getCourseContainers(courseId: number): Promise<CourseContainers> {
    const { apiGetCourseContainers } = apiConfig.getStaticUrls();

    return getFetch(`${apiGetCourseContainers}${courseId}/`);
}
